import React, { useEffect } from "react";
import { useLocation, useNavigate } from 'react-router-dom';
import { helpers } from "@shared";
import { Resident } from "@common";

const OnboardMultipleAccountsInfo = () => {

    const navigate = useNavigate();
    const location = useLocation();
    const { state: { accounts } } = location;

    const next = () => {
        helpers.navigateNext(location, navigate);
    };

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return (
        <div className="page-content-wrapper gap-y-6">
            <h1 className="page-header">Onboard Residents</h1>
            <div className="page-subheader ">It looks like you have multiple residents listed for your account, we’ll walk through setting up the following residents:</div>
            {
                accounts.map(a => {
                    const { idAccount, residentName } = a;
                    return (
                        <Resident key={idAccount} residentName={residentName} />
                    );
                })
            }
            <div className="page-action">
                <button type="button" className="btn btn-primary" onClick={next}>Continue</button>
            </div>
        </div>
    );
};

export default OnboardMultipleAccountsInfo;
